import {
    deletePlayerMedia,
    getPlayerMediaList,
    updatePlayerMedia,
    uploadPlayerMedia
} from "../../helpers/playerMediaService";
import {checkError, closeAlert, receiveErrorAlert, receiveSuccessAlert} from "../commonsActions";

export const FETCH_PLAYER_MEDIA_LIST_BEGIN = 'FETCH_PLAYER_MEDIA_LIST_BEGIN';
export const FETCH_PLAYER_MEDIA_LIST_SUCCESS = 'FETCH_PLAYER_MEDIA_LIST_SUCCESS';
export const FETCH_PLAYER_MEDIA_LIST_ERROR = 'FETCH_PLAYER_MEDIA_LIST_ERROR';

/*
 * action creators
 */

const fetchPlayerMediaListSuccess = res => ({
    type: FETCH_PLAYER_MEDIA_LIST_SUCCESS,
    payload: {
        playerMediaList: res.data,
        numberOfElements: res.numberOfElements,
        totalElements: res.totalElements,
        totalPages: res.totalPages
    }
});

const fetchPlayerMediaListError = error => ({
    type: FETCH_PLAYER_MEDIA_LIST_ERROR,
    payload: {
        error: error,
    }
});

export const fetchPlayerMediaList = query => dispatch => {
    dispatch({type: FETCH_PLAYER_MEDIA_LIST_BEGIN});
    return getPlayerMediaList(query).then(res => {
        dispatch(fetchPlayerMediaListSuccess(res));
        return res;
    }, error => {
        dispatch(fetchPlayerMediaListError(error))
        dispatch(checkError(error));
        dispatch(receiveErrorAlert(error));
        setTimeout(() => {
            dispatch(closeAlert());
        }, 2000);
    })
};

export const saveNewPlayerMedia = media => dispatch => {
    const data = new FormData();
    data.append('companyId', media.companyId);
    data.append('folderId', media.folderId);
    data.append('name', media.file.name);
    data.append('file', media.file);
    return uploadPlayerMedia(data).then(res => {
        dispatch(receiveSuccessAlert('Success'));
        setTimeout(() => {
            dispatch(closeAlert());
        }, 2000);
        return res;
    })
};

export const updateSinglePlayerMedia = media => dispatch => {
    return updatePlayerMedia(media).then(res => {
        dispatch(receiveSuccessAlert('Update Successful'));
        setTimeout(() => {
            dispatch(closeAlert());
        }, 2000);
        return res;
    })
};

export const removePlayerMedia = mediaId => dispatch => {
    return deletePlayerMedia(mediaId).then(res => {
        return res;
    }, error => {
        dispatch(checkError(error));
        dispatch(receiveErrorAlert(error));
        setTimeout(() => {
            dispatch(closeAlert());
        }, 2000);
    })
};


// WEBPACK FOOTER //
// ./src/actions/player/playerMediaActions.js